import { inject, Provider } from '@angular/core';
import { provideEgLauncher, provideEgLauncherIdentity } from '@expertgroup/shell';
import { environment } from '@/environments/environment';
import { AuthService } from '@/app/core/auth/auth.service';

/**
 * Launcher u topbaru (@expertgroup/shell 0.12+).
 *
 * Identity daje pristup trenutnog korisnika i registrovane UI klijente (`myApplications` na `<issuer>/graphql`, sa
 * korisnickim bearer tokenom); adrese iz `environment.ecosystem` su samo opcioni override i ne daju pristup.
 * Bez `provideEgLauncherIdentity` launcher ne prikazuje nijedan link.
 *
 * Ovde je issuer sam ovaj backend, pa je endpoint isti onaj `/graphql` koji vec koristi Apollo (`environment.graphqlEndpoint`).
 * Provider salje eksplicitan `Authorization` header preko HttpClient-a, mimo Apollo lanca; ova aplikacija nema HTTP
 * interceptor koji bi ga prepisao (angular-auth-oidc-client-ov interceptor nije registrovan). Ko ga ikad doda, mora da
 * propusti zahtev koji vec nosi `Authorization` — to cuva `launcher.providers.spec.ts`.
 */
export const launcherProviders: Provider[] = [
    provideEgLauncher(environment.ecosystem),
    provideEgLauncherIdentity(() => {
        const auth = inject(AuthService);
        return { issuer: environment.issuer, accessToken: () => auth.getAccessToken() };
    })
];
